// Module
var code = `<form-section form-title="'Related customers'">
    <table class="table table--wide">
        <thead>
        <th class="numbers">No.</th>
        <th>Name</th>
        <th>Relationship</th>
        <th ng-if="\$ctrl.isRelativeSignatory && \$ctrl.cfg.visible('customer', 'related_people', 'withdrawal_limit')">Withdrawal limit</th>
        <th>Beneficiary</th>
        <th>Dependent</th>
        <th>Birth Date</th>
        <th>Birth place</th>
        <th>Mobile number</th>
        <th>Nature of work</th>
        <th>Customer Number</th>
        <th>Mother Branch</th>
        <th>&nbsp;</th>
        </thead>
        <tbody class="tbody">
        <tr ng-repeat="rel in \$ctrl.profile.relatedCustomers">
            <td>{{\$index+1}}.</td>
            <td class="label">
                {{rel.effectiveName}}
            </td>
            <td class="label">
                <multiselect ng-model="rel.typeIds"
                             ng-disabled="!\$ctrl.editMode"
                             label-property="'description'"
                             value-property="'id'"
                             items="rel.customerType === 'CORPORATE' ? \$ctrl.corporateRelatedCustomerOptions : \$ctrl.individualRelatedCustomerOptions"
                             ng-change="\$ctrl.showWarningOnSignatoryRemoval(rel)"
                             select-all-option="rel.customerType === 'INDIVIDUAL'"
                             ng-required="true">
                </multiselect>
                <div class="relationship-options">
                    <select ng-if="rel.typeIds.includes(-1) && \$ctrl.profile.customerType === 'INDIVIDUAL'"
                            ng-model="rel.individualCompanyRoleTypeId"
                            ng-disabled="!\$ctrl.editMode"
                            ng-options="o.id as o.description for o in \$ctrl.individualCompanyRoleTypeOptions"
                            ng-change="\$ctrl.showWarningOnSignatoryRemoval(rel)"
                            ng-required="true">
                    </select>
                    <select ng-if="rel.typeIds.includes(-1) && \$ctrl.profile.customerType === 'CORPORATE'"
                            ng-model="rel.corporateCompanyRoleTypeId"
                            ng-disabled="!\$ctrl.editMode"
                            ng-options="o.id as o.description for o in \$ctrl.corporateCompanyRoleTypeOptions"
                            ng-change="\$ctrl.showWarningOnSignatoryRemoval(rel)"
                            ng-required="true">
                    </select>
                </div>
            </td>
            <td ng-if="\$ctrl.isRelativeSignatory && \$ctrl.cfg.visible('customer', 'related_people', 'withdrawal_limit')">
                <cash ng-if="\$ctrl.hasSignatoryRelativeType(rel.typeIds, \$ctrl.dict.RELATIVE_TYPE)"
                      ng-show="\$ctrl.editMode"
                      ng-disabled="!\$ctrl.editMode"
                      ng-model="rel.withdrawalLimit"
                      ng-required="\$ctrl.cfg.required('customer', 'related_people', 'withdrawal_limit')"></cash>
                <span ng-if="!\$ctrl.editMode">{{rel.withdrawalLimit | nxCurrency}}</span>
            </td>
            <td class="label">
                <select
                        ng-model="rel.beneficiary"
                        ng-disabled="!\$ctrl.editMode"
                        boolean-options
                        ng-required="true">
                </select>
            </td>
            <td class="label">
                <select
                        ng-model="rel.dependent"
                        ng-disabled="!\$ctrl.editMode"
                        boolean-options
                        ng-required="true">
                </select>
            </td>
            <td class="label">
                {{rel.birthDate | prettyDate}}
            </td>
            <td class="label">
                {{rel.birthPlace}}
            </td>
            <td class="label">
                <telephone ng-model="rel.mobileNumber"
                           ng-disabled="true"></telephone>
            </td>
            <td class="label">
                {{rel.natureOfWork}}
            </td>
            <td class="label">
                {{rel.customerNumber}}
            </td>
            <td class="label">
                {{rel.branchName}}
            </td>
            <td class="buttons">
                <button type="button"
                        class="btn btn-primary"
                        ng-if="!\$ctrl.editMode"
                        ng-click="\$ctrl.openCustomer(rel.relativeCustomerId)">Open
                </button>
                <button type="button"
                        class="btn btn-danger"
                        ng-if="\$ctrl.editMode"
                        ng-click="\$ctrl.removeRelative(rel)">Remove
                </button>
            </td>
        </tr>
        <tr ng-if="\$ctrl.editMode">
            <td>{{\$ctrl.profile.relatedCustomers.length + 1}}.</td>
            <td colspan="{{ \$ctrl.isRelativeSignatory ? 13 : 12 }}">
              <customer-picker on-choose="\$ctrl.addRelative(customer)"></customer-picker>
            </td>
        </tr>
        </tbody>
    </table>
</form-section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/related-customers/related-customers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;